import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from "react";
import Moment from "moment";
import { connect } from "react-redux";
import { getAttendanceColor } from "helpers/attendance";
import { Checkbox, Button, translate, getActiveLanguage } from "@haldor/ui";
import PostContent from "components/Presentation/PostContent";
var SingleModalLesson = /*#__PURE__*/function (_Component) {
  function SingleModalLesson(props) {
    var _this;
    _classCallCheck(this, SingleModalLesson);
    _this = _callSuper(this, SingleModalLesson, [props]);
    _defineProperty(_this, "componentDidMount", function () {
      Moment.locale(getActiveLanguage());
    });
    /* Form methods */
    _defineProperty(_this, "onAbsenceSubmit", function () {
      var lesson = _this.props.activeLesson;
      var values = {
        startTime: Moment.utc(lesson.startTime).local().format("YYYY-MM-DDTHH:mm:ss"),
        endTime: Moment.utc(lesson.startTime).local().add(lesson.length, "minutes").format("YYYY-MM-DDTHH:mm:ss"),
        userId: _this.props.activeStudent
      };
      return new Promise(function (resolve) {
        if (values.id != null) {
          _this.props.updateAbsence(values).then(function () {
            resolve(1);
          });
        } else {
          _this.props.submitAbsence(values).then(function () {
            resolve(1);
          });
        }
      });
    });
    _defineProperty(_this, "onEntireLesson", function () {
      _this.setState({
        entireLesson: true
      });
    });
    _defineProperty(_this, "onPartLesson", function () {
      _this.setState({
        entireLesson: false
      });
    });
    /* Render methods */
    _defineProperty(_this, "renderAbsenceForm", function () {
      // Not used at the moment
      var lesson = _this.props.activeLesson;
      var foundAbsence = null;
      if (_this.props.absences != null) {
        foundAbsence = _this.props.absences.find(function (absence) {
          return absence.startTime == _this.props.activeLesson.startTime;
        });
      }
      var translate = _this.props.translate;
      return /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: "2rem"
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("h3", null, translate("Will the student be absent the entire lesson?")), /*#__PURE__*/React.createElement(Checkbox, {
        label: translate("Entire lesson"),
        onChange: _this.onEntireLesson,
        value: _this.state.entireLesson
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: "0.5rem"
        }
      }, /*#__PURE__*/React.createElement(Checkbox, {
        label: translate("Part of lesson"),
        onChange: _this.onPartLesson,
        value: !_this.state.entireLesson
      })), !_this.state.entireLesson ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: "1.5rem"
        }
      }, /*#__PURE__*/React.createElement("input", {
        type: "number",
        max: lesson.length,
        min: "0",
        style: {
          marginRight: "0.4rem"
        }
      }), translate("minutes of lesson")) : null), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: "1.5rem"
        },
        className: "form-row spacing submit"
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: _this.onAbsenceSubmit
      }, foundAbsence != null ? translate("Update absence") : translate("Report absence")), foundAbsence != null ? /*#__PURE__*/React.createElement(Button, {
        type: "secondary"
      }, translate("Remove absence")) : null));
    });
    _defineProperty(_this, "renderAttendanceInfo", function (attendance) {
      var translate = _this.props.translate;
      if (attendance == null) {
        if (_this.props.activeLesson.type == "LESSON") {
          return /*#__PURE__*/React.createElement("div", {
            className: "form-row spacing"
          }, translate("No attendance / absence is reported for this lesson."));
        }
      }
      var content = "";
      if (_this.props.activeLesson.type == "LESSON") {
        if (attendance != null) {
          if (attendance.attendanceType == "PRESENT") {
            content = translate("Present");
          }
          if (attendance.attendanceType == "INVALID_ABSENCE") {
            content = translate("Invalid absent");
          }
          if (attendance.attendanceType == "VALID_ABSENCE") {
            content = translate("Valid absent");
          }
          if (attendance.attendanceType == "INVALID_LATE") {
            content = translate("Partly invalid absent");
          }
          if (attendance.attendanceType == "VALID_LATE") {
            content = translate("Partly absent");
          }
        }
      }
      if (_this.props.activeLesson.type == "LESSON") {
        return /*#__PURE__*/React.createElement("div", {
          className: "form-row spacing",
          style: {
            color: getAttendanceColor(attendance)
          }
        }, content, attendance.lateDuration != null && attendance.lateDuration > 0 ? " (" + attendance.lateDuration + " " + translate("minutes") + ")" : null);
      }
    });
    _this.state = {
      entireLesson: true
    };
    return _this;
  }
  _inherits(SingleModalLesson, _Component);
  return _createClass(SingleModalLesson, [{
    key: "render",
    value: function render() {
      if (this.props.activeLesson == null) {
        return null;
      }
      var lesson = this.props.activeLesson;
      var attendance = lesson.attendance;
      return /*#__PURE__*/React.createElement("div", {
        className: "form-container form"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, (lesson === null || lesson === void 0 ? void 0 : lesson.type) === 'CALENDAR_EVENT' ? /*#__PURE__*/React.createElement("div", null, " ", /*#__PURE__*/React.createElement("h3", null, lesson.title), /*#__PURE__*/React.createElement(PostContent, null, lesson.description)) : /*#__PURE__*/React.createElement("div", null, " ", lesson.title, /*#__PURE__*/React.createElement("br", null)), Moment.utc(lesson.startTime).local().format("dddd  Do MMMM[,]  LT").capitalize(), Moment.utc(lesson.startTime).local().add(lesson.length, "minutes").format("[ ".concat(this.props.translate("to"), "] LT")) + "."), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }), /*#__PURE__*/React.createElement("div", {
        className: "form-divider"
      }), this.renderAttendanceInfo(attendance));
    }
  }]);
}(Component);
function mapStateToProps(state) {
  return {
    activeStudent: state.guardians.activeStudent,
    // absences: state.absence.user,
    attendance: state.attendance.user,
    translate: translate(state.Languages.translations)
  };
}
export default connect(mapStateToProps, {
  //getUserAbsence,
  //updateAbsence,
  //submitAbsence,
})(SingleModalLesson);